<sc-flex>
    {{reference.name}}
    <sc-content-spacer grow></sc-content-spacer>
    <sc-icon iconClass="fa-trash" (click)="remove()"></sc-icon>
</sc-flex>
